<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { QuoteIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .insertBelow(({ escapeList: true, onlyIfEmpty: true }))
    .toggleBlockquote()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="QuoteIcon"
    shortcut=">"
    @click="run"
    @keydown.enter="run"
  >
    Quote
  </SuggestionListItem>
</template>
